"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fireOnce = exports.trackStructuredEvent = exports.trackPageView = exports.trackCustomEvent = exports.initializeSnowplowTracker = exports.careResourceContext = void 0;
const browser_tracker_1 = require("@snowplow/browser-tracker");
const browser_plugin_link_click_tracking_1 = require("@snowplow/browser-plugin-link-click-tracking");
const constants_1 = require("./constants");
function careResourceContext(name, token) {
    return {
        schema: constants_1.ContextSchema.CareResource,
        data: {
            careCollectionResourceToken: token,
            name,
        },
    };
}
exports.careResourceContext = careResourceContext;
function initializeSnowplowTracker(
/** e.g. 'buoy-public-site' */
appId, snowplowCollectorUrl, additionalOptions) {
    if (typeof window !== "undefined") {
        (0, browser_tracker_1.newTracker)("sp", snowplowCollectorUrl, {
            appId,
            respectDoNotTrack: true,
            plugins: [(0, browser_plugin_link_click_tracking_1.LinkClickTrackingPlugin)()],
            ...additionalOptions,
        });
        (0, browser_plugin_link_click_tracking_1.enableLinkClickTracking)();
    }
}
exports.initializeSnowplowTracker = initializeSnowplowTracker;
function trackCustomEvent(schema, data, eventContext) {
    if (typeof window !== "undefined") {
        (0, browser_tracker_1.trackSelfDescribingEvent)({
            event: {
                schema,
                data,
            },
            context: eventContext ? [eventContext] : undefined,
        });
    }
}
exports.trackCustomEvent = trackCustomEvent;
function trackPageView(trackingConfig = constants_1.defaultSnowplowActivityTrackingConfig) {
    if (typeof window !== "undefined") {
        (0, browser_tracker_1.enableActivityTracking)(trackingConfig);
        (0, browser_plugin_link_click_tracking_1.refreshLinkClickTracking)();
        (0, browser_tracker_1.trackPageView)();
    }
}
exports.trackPageView = trackPageView;
function trackStructuredEvent(event) {
    if (typeof window !== "undefined") {
        (0, browser_tracker_1.trackStructEvent)(event);
    }
}
exports.trackStructuredEvent = trackStructuredEvent;
/**
 * Ensure tracking event is fired only once.
 *
 * @example
 * const event = {
 *   action: "interview started",
 *   category: "interview"
 * }
 * const key = `${event.category}:${event.action}`
 * fireOnce(() => snowplowStructEvent(event), key)
 *
 * */
function fireOnce(callback, key) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.SNOWPLOW_EVENTS = window.SNOWPLOW_EVENTS || {};
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!window.SNOWPLOW_EVENTS[key]) {
        callback();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.SNOWPLOW_EVENTS[key] = Date.now();
    }
}
exports.fireOnce = fireOnce;
//# sourceMappingURL=utils.js.map